module.exports = __webpack_public_path__ + "media/images/covers/foundation/about-prepworks-foundation-4824917547df493546654f169b47fc3d.jpg";